import { LoadableLazy, type LoadableType } from '@confluence/loadable';

import type { ShareContextModalProps } from './ShareContextModal.tsx';

/**
 * The share-context modal's lazy boundary, in its own module so more than one owner can mount it.
 *
 * `TeamworkGraphShareContextButton` owns the modal at its panel and modal call sites, but the
 * byline popup cannot: a click inside the modal's portal reads as an outside click to the popup,
 * which closes it and unmounts both the button and its modal. There the byline owns the modal
 * instead and the button only reports the intent via `onOpen`. Both paths share this boundary so
 * they resolve to the same chunk.
 */
export const ShareContextModalLoadable: LoadableType<ShareContextModalProps> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ShareContextModal" */ './ShareContextModal.tsx'))
			.ShareContextModal,
});
